import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import {
  faCheck,
  faCheckCircle,
  faExclamation,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Auction } from '../../../../articles-manager/interfaces/auction.interface';

@Component({
  selector: 'app-success-bid-dialog',
  templateUrl: './bid-success-dialog.component.html',
  styleUrls: ['./bid-success-dialog.component.scss'],
})
export class BidSuccessDialogComponent implements OnInit {
  @Input() amount: number;
  @Input() inPreEventStatus: boolean = false;
  @Input() isBuyNow: boolean = false;
  @Input() selectedAuction: Auction;
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faExclamation = faExclamation;
  faCheck = faCheck;

  constructor(
    public activeModal: NgbActiveModal,
    public authService: AuthService
  ) {}

  ngOnInit(): void {}
}
